import React, { useState } from 'react';
import CLcss from './checklist.module.css';
import { axiosAuthFetch } from '../../helpers/apiActions/authFetch';
import { API_BASE_URL } from '../../constants';
import { getLocalStorageItem } from '../../helpers/storage';
import Loader from '../loader';
// import CustomAlert from '../customAlert';

export default function Checklist ({ checks, formID, orderedProductId, customerData }) {

    const [checkedItems, setCheckedItems] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const userInfo = getLocalStorageItem('vp-portal-user')
    const userID = userInfo.user.id;
    const opID = orderedProductId;
    const customerId = customerData.id;
    console.log(checks, customerData);

    const checkIDS = [];

    for (const check of checks) {
        checkIDS.push(check.id);
    }

    const checksByCategory = checks.reduce((acc, check) => {
        const category = check.attributes.category || 'Uten kategori';
        if(!acc[category]) {
            acc[category] = [];
        }
        acc[category].push(check);
        return acc;
    }, {});

    const handleItemClick = (checkId) => {
        setCheckedItems((prevCheckedItems) => {
            const updatedCheckedItems = { ...prevCheckedItems };
            updatedCheckedItems[checkId] = !updatedCheckedItems[checkId];
            return updatedCheckedItems;
        });
    };

    

        // Opprett et nytt array med sjekkobjekter som inkluderer hele sjekkobjektet og merkestatusen
          

    // const handleSubmit = async () => {
        const checkedItemsWithStatus = checks.map(check => ({
            ...check,
            isChecked: !!checkedItems[check.id] // Konverterer undefined eller true/false til true/false
        }));

    const handleSubmit = async () => {
        setIsLoading(true);
        try {

            const createdIDS = [];

            // Loop through checkedItemsWithStatus array
            for (const checkedItem of checkedItemsWithStatus) {
                const { id, isChecked } = checkedItem;
                const completed = !!isChecked; // Konverterer undefined eller true/false til true/false

                const checkID = parseInt(id, 10);
                console.log(checkedItem);
                console.log(id, completed);
    
                //Gjør axiosAuthFetch-forespørsel for hvert sjekk
                const response = await axiosAuthFetch(`${API_BASE_URL}/service-actions`, {
                    data: {
                        completed: completed,
                        service_check: {
                            connect: [checkID]
                        },
                        service_form: {
                            connect: [parseInt(formID)] // Du må erstatte formID med den faktiske formID-en
                        }
                    }
                }, 'POST');
                createdIDS.push(response.data.id);
                console.log(response.data);
            }

            console.log('Sending to Strapi:', {
                service_actions: { connect: createdIDS },
                service_form: { connect: [formID] },
                service_checks: { connect: checkIDS },
                ordered_product: { connect: [opID] },
                //year: JSON.stringify(currentYear),
                service_info: {
                    performed_by: { connect: [userID] },
                    // date_performed: currentDate.toISOString().split('T')[0],
                    // next_service_date: nextYearDate.toISOString().split('T')[0],
                    customer: { connect: [customerId] }
                }
            });

            const currentDate = new Date();
            const nextYearDate = new Date();
            nextYearDate.setFullYear(currentDate.getFullYear() + 1);
            const currentYear = currentDate.getFullYear();

            const executedServiceResponse = await axiosAuthFetch(`${API_BASE_URL}/executed-services`, {
                data: {
                    service_actions: {
                        connect: createdIDS
                    },
                    service_form: {
                        connect: [parseInt(formID)]
                    },
                    service_checks: {
                        connect: checkIDS.map(id => parseInt(id, 10))
                    },
                    ordered_product: {
                        connect: [parseInt(opID, 10)]
                    },
                    year: JSON.stringify(currentYear),
                    service_info: {
                        performed_by: {
                            connect: [parseInt(userID, 10)]
                        },
                        date_performed: currentDate.toISOString().split('T')[0],
                        next_service_date: nextYearDate.toISOString().split('T')[0],
                        customer: {
                            connect: [parseInt(customerId, 10)]
                        }
                    }
                }
            }, 'POST');
            console.log(executedServiceResponse.data);
            console.log('Alle service-actions ble opprettet vellykket');
            alert('Service utført!')
            setIsLoading(false);
            window.location.reload();
        } catch (error) {
            console.error('Feil ved opprettelse av service-actions:', error);
        }
    };

    if(isLoading) {
        return(<div><Loader /></div>)
    }

    return(
        <div>
            {Object.entries(checksByCategory).map(([category, checks]) => (
                <div key={category} className={CLcss.rute}>
                    <div className={CLcss.tableHeader}>
                        <h2 className={CLcss.category}>{category}</h2>
                        <div className={CLcss.JA}>JA</div>
                    </div>
                    <div className={CLcss.subRute}>
                    {checks.map(check => (
                        <div key={check.id} className={CLcss.checkItem}>
                            <div className={CLcss.checkP}>{check.attributes.description}</div>
                            <div className={`${CLcss.checkBox} ${checkedItems[check.id] ? CLcss.checked : '' }`}
                                onClick={() => handleItemClick(check.id)}>
                                <div className={CLcss.checkBoxCircle}></div>
                            </div>
                        </div>
                    ))}
                    </div>
                </div>
            ))}
            <div className={CLcss.submitButton} onClick={handleSubmit}>
               Send
            </div>
        </div>
    )
}






        // <div>
        //     {checks.map((check, index) => (
        //         <div key={index} className={CLcss.checkItem}>
        //             <div className={CLcss.checkP}>{check.attributes.description}</div>
        //             <div className={`${CLcss.checkBox} ${checkedItems[index] ? CLcss.checked : '' }`}
        //                 onClick={() => handleItemClick(index)}>
        //                 <div className={CLcss.checkBoxCircle}></div>
        //             </div>
        //         </div>
        //     ))}
        //     <div className={CLcss.submitButton} onClick={handleSubmit}>
        //        Send
        //     </div>
        // </div>